export default "__VITE_ASSET__DbxCH1fJ__"